<template>
  <img class="image" :src="imageurl" />
</template>

<script>
export default {
  components: {},
  props: ["url"],
  data() {
    return {
      imageurl: this.url
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.image {
  width: 100%;
  height: 100%;
}
</style>
